import * as React from "react";
import { cn } from "@/lib/utils";
import { useSocialCoachSession } from "@/utils/useSocialCoachSession";

/**
 * Where to go when refining isn't getting there: support can hand-edit the design's HTML when the AI gets it
 * badly wrong or leaves it in a broken state.
 */
export const SupportLine: React.FC<{
  className?: string;
  /** Overrides the session's support address */ email?: string;
}> = ({ className, email }) => {
  const session = useSocialCoachSession();
  const supportEmail = email ?? session.supportEmail;
  return (
    <p className={cn("text-sm text-slate-600", className)}>
      Tried a few times and it's still not right? Email{" "}
      <a href={`mailto:${supportEmail}`} className="font-medium text-primary hover:underline">
        {supportEmail}
      </a>{" "}
      with what you're after, and our team can fix the design by hand.
    </p>
  );
};
